import clsx from 'clsx';
import { useState, type HTMLAttributes } from 'react';
import { tlwTwMerge } from '@trg/utils';
import { Icon } from '@trg/tlw-ui-component';

export type AccordionProps = HTMLAttributes<HTMLDivElement> & {
  defaultExpand?: boolean;
  label: string;
};

export function Accordion({
  defaultExpand = false,
  label,
  className,
  children,
  onClick,
  ...props
}: AccordionProps) {
  const [isExpand, setIsExpand] = useState(defaultExpand);

  const handleToggle = () => setIsExpand(!isExpand);

  return (
    <div
      className={tlwTwMerge(
        'tlw-grid tlw-duration-300',
        isExpand && 'tlw-bg-gray-300',
        className
      )}
      style={{
        gridTemplateRows: `max-content ${isExpand ? 1 : 0}fr`,
      }}
      {...props}
    >
      <div
        className={clsx(
          'tlw-txt-zh-head-8 tlw-text-txt-700 tlw-py-1 tlw-pl-5 tlw-pr-6 tlw-flex tlw-items-center tlw-justify-between tlw-gap-5 tlw-duration-300 tlw-overflow-hidden tlw-cursor-pointer hover:tlw-text-txt-core',
          isExpand && 'tlw-text-txt-core'
        )}
        onClick={handleToggle}
      >
        <p className="tlw-line-clamp-1" title={label}>
          {label}
        </p>

        <Icon
          className="tlw-shrink-0"
          name={isExpand ? 'Minus' : 'Plus'}
          size={16}
        />
      </div>

      <div className="tlw-min-h-0 tlw-overflow-hidden" onClick={handleToggle}>
        {children}
      </div>
    </div>
  );
}
